export const extractQueryParams = () => {
  const url = window.location.href
  const regex = /[?&]([^=#]+)=([^&#]*)/g
  const params = {}
  let match

  while ((match = regex.exec(url))) {
    params[match[1]] = match[2]
  }

  // window.history.replaceState({}, document.title, window.location.href.replace(window.location.search, ''));

  return params
}
